import { render, staticRenderFns } from "./AbsenceBalance.vue?vue&type=template&id=2525c311"
import script from "./AbsenceBalance.vue?vue&type=script&lang=js"
export * from "./AbsenceBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports